import "../../styles/Intro.css";
import { useTypewriter } from "react-simple-typewriter";

const Intro = () => {
  const [text] = useTypewriter({
    words: ["Front End Developer", "problem solver", "team member", "cat dad"],
    typeSpeed: 100,
    deleteSpeed: 100,
    delaySpeed: 2000,
    loop: false,
  });

  return (
    <section className="intro" id="home">
      <div className="intro__about">
        <p>Hi, my name is</p>
        <div className="intro__about--highlight">
          <h1>Jarrod Gilliland</h1>
          <p className="intro__about--title">I'm a passionate {text}</p>
        </div>
        <p className="intro__about--summary">
          I'm a{" "}
          <span style={{ color: "#1a9a92", fontWeight: "500" }}>
            Front End Developer
          </span>{" "}
          with a strong personal portfolio and passion to create meaningful and
          impactful work. I am well-versed in the front end ecosystem and able
          to{" "}
          <span style={{ color: "#1a9a92", fontWeight: "500" }}>
            quickly adopt and leverage new technologies
          </span>{" "}
          that arise.
        </p>
        <div className="intro__button">
          <a href="resume.pdf" download={"Jarrod Gilliland Resume"}>
            Download Resume
          </a>
        </div>
      </div>
    </section>
  );
};

export default Intro;
